import { MODAL_OPEN, MODAL_CLOSE, MODAL_STATUS_CHANGE } from "../action-types/modal"

const initModalShowStatus = {
    modalProjectId: null,
    currentStep: 1,
    modalShow: false,
}
export default function modalReducer(state = initModalShowStatus, action) {
    switch (action.type) {
        case MODAL_OPEN: {
            return {
                ...state,
                modalShow: true,
            }
        }
        case MODAL_CLOSE: {
            return {
                ...state,
                modalShow: false,
            }
        }
        case MODAL_STATUS_CHANGE: {
            return {
                ...state,
                modalProjectId: action.payload.modalProjectId,
                currentStep: action.payload.currentStep,
            }
        }
        default:
            return state
    }
}
